export const proxyAvailabilityErrorLabel = (message: string): string => {
  const value = (message || '').toLowerCase();
  if (value.includes('lookup ') || value.includes('resolve ')) return 'DNS 解析失败';
  if (value.includes('socks5 auth') || value.includes('authentication') || value.includes('socks5 user/pass')) return 'SOCKS5 认证失败';
  if (value.includes('socks5 handshake') || value.includes('socks5 greeting')) return 'SOCKS5 握手失败';
  if (value.includes('socks5 connect')) return '目标连接失败';
  if (value.includes('tcp connect') || value.includes('dial tcp')) return 'TCP 连接失败';
  if (value.includes('ip_geo_detect') || value.includes('outbound ip')) return '出口 IP 检测失败';
  return '节点检测失败';
};
